exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.text-span{color:#6d7278;font-size:1.2rem}", ""]);

// exports
